export default __webpack_public_path__ + "static/media/pot3.5a06b7e5.svg";